import { getJobBoardsByName, IEmailDTO, IJob, IJobBoard } from 'wisestep-api';

import { failed, success, warning } from '../../../../../utils/NotificationMessages';

export const getJobBoards = async (jobBoardName: string) => {
  const jobBoardsByName = await getJobBoardsByName(jobBoardName);
  return jobBoardsByName.data;
};

export interface IJobData {
  jobData: IJob;
}

export const publishSuccess = () => success('Job has been published successfully !!');
export const publishFailed = () => failed('Failed to publish job, Please try again !! ');
export const publishCreditsWarning = () =>
  warning(
    'You do not have enough credits to publish job, Contact Admin to allocate more credits or unpublish your already published jobs'
  );

const today: Date = new Date();
export const publishJobBoardValues: IJobBoard = {
  username: '',
  password: '',
  id: '',
  workspaceId: '',
  workspaceName: '',
  jobBoardName: '',
  jobBoardType: '',
  autoRefresh: '',
  jobDuration: '',
  careerAdNetwork: '',
  diceGroupId: '',
  createdBy: '',
  jobBoardSharedTeamDetails: [],
  jobBoardSharedUsers: [],
  userFirstName: '',
  userLastName: '',
  userTitle: '',
  isJobBoardAdminUser: false,
  userCompanyId: '',
  userIdAtJobBoard: '',
  createdOn: today,
  expiry: 60,
  ackToEmails: [],
  clientName: false,
  whoPosted: 'Who posted job on Job boards',
  displaySalary: 'No',
  sendEmail: 'Yes',
  feedId: '',
};

export const publishEmailValues: IEmailDTO = {
  id: '',
  from: 'Karunaker.reddy@wisestep-inc.com',
  fromName: '',
  to: [],
  cc: [],
  bcc: [],
  replyTo: '',
  subject: '',
  body: '<p>Hi,</p><p>Your workspace owner allowed you to post jobs and you can post only undefined jobs per month.</p><p>Regards</p><p>Wisestep Team</p>',
  resumeFileName: '',
  resumeFileLocation: '',
  attachements: [],
  candidateId: '',
  jobId: '',
  teamId: '',
  jobTitle: '',
  unsubscribeText: '',
  recruiterId: '',
  workspaceId: '',
  interactionId: '',
  isMappingInteraction: false,
  jobIds: [],
  hasPreMailingFlowsApplied: false,
  source: '',
  recruiterFullName: '',
  createdBy: '',
  workspaceName: '',
};

export interface JobBoardValues {
  jobBoardName: string;
  username: string;
  password: string;
}

export const jobBoardDefaultValues: JobBoardValues = {
  jobBoardName: '',
  username: '',
  password: '',
};

export const getAccountCount = (jobBoardResponse) => {
  const allJobBoardResponse =
    jobBoardResponse.Monster.length +
    jobBoardResponse.Dice.length +
    jobBoardResponse.CareerBuilder.length +
    jobBoardResponse.TechFetch.length;
  return allJobBoardResponse;
};
